import Cookies from "universal-cookie";

export const setQuizParticipationCookie = (quizId: string, competitionExpirationDate: Date) => {
  const cookies = new Cookies();
  cookies.set(`Participation_${quizId}`, quizId, {
    path: "/",
    expires: competitionExpirationDate,
  });
};
